import React from "react";
import { Link } from "react-router-dom";

import AffiliationCertificate from "../Assets/CBSE_AFFILIATION_LETTER.pdf";
import SocietyCertificate from "../Assets/SOCIETYREGISTRATION.pdf";
import BuildingSafetyCertficate from "../Assets/NATIONAL_BUILDING_CODE.pdf";
import FireCertificate from "../Assets/FIRE_NOC_RENEWAL.pdf";
import NOC_CBSE from "../Assets/NOC_CBSE.pdf";
import BSA_Permanent_Affiliation_Letter from "../Assets/BSA_Permanent_Affiliation_Letter.pdf";
import Dios from "../Assets/DIOS_AFFILIATION EXTENSION CERTIFICATE.pdf";
import WaterCertificate from "../Assets/SANITRYCERTIFICATE.pdf";
import KPSCalendor from "../Assets/KPSCalendor.pdf";
import SMCommitee from "../Assets/School_Management_Commitee.pdf";
import PTAssociation from "../Assets/Parents_Teachers_Association.pdf";
import CBSEResult from "../Assets/CBSEResult.pdf";
import SelfCertificate from "../Assets/SelfCertificate.pdf";
import TEACHERLIST from "../Assets/TEACHERLIST.pdf";

const Section = ({ title, children }) => (
  <div className="mb-12">
    <h3 className="bg-gradient-to-r from-red-600 to-[#ff4e1c] text-white px-4 py-2 font-semibold rounded-t-md">
      {title}
    </h3>
    <div className="border border-red-200 rounded-b-md overflow-hidden">
      {children}
    </div>
  </div>
);

const Row = ({ sl, label, value, link }) => (
  <div className="grid grid-cols-12 border-b last:border-none">
    <div className="col-span-2 bg-red-100 px-3 py-3 font-medium text-gray-800">
      {sl}
    </div>
    <div className="col-span-5 px-3 py-3 text-gray-700">{label}</div>
    <div className="col-span-5 px-3 py-3">
      {link ? (
        <Link
          to={link}
          target="_blank"
          className="text-red-600 font-medium hover:underline"
        >
          View Details
        </Link>
      ) : (
        <span className="text-gray-700">{value}</span>
      )}
    </div>
  </div>
);

export default function Disclosure() {
  return (
    <>
      <section className="bg-gradient-to-r from-red-600 to-[#ff4e1c] py-24 text-white">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl font-bold" data-aos="fade-down">
            Mandatory Disclosure
          </h1>
          <p className="mt-3 text-sky-100 text-base md:text-lg" data-aos="fade-up" data-aos-delay="150">
            Transparency, Compliance & Accountability
          </p>
        </div>
      </section>

      <div className="max-w-6xl mx-auto px-4 py-14">
        <Section title="A: GENERAL INFORMATION">
          <Row sl="1" label="NAME OF THE SCHOOL" value="Krishna Public School" />
          <Row sl="2" label="AFFILIATION NO." value="2132602" />
          <Row sl="3" label="SCHOOL CODE" value="70808" />
          <Row sl="4" label="COMPLETE ADDRESS WITH PIN CODE" value="NH-2A, Mugal Road, Sikandra, Kanpur Dehat, UP – 209125"/>
          <Row sl="5" label="SCHOOL EMAIL ID" value="kpssikandra@gmail.com"/>
          <Row sl="6" label="CONTACT DETAILS" value="+91 6306089776, +91 6388567798"/>
        </Section>

        <Section title="B: DOCUMENTS AND INFORMATION">
          <Row sl="1" label="AFFILIATION / EXTENSION LETTER" link={AffiliationCertificate}/>
          <Row sl="2" label="SOCIETY REGISTRATION CERTIFICATE" link={SocietyCertificate} />
          <Row sl="4" label="BUILDING SAFETY CERTIFICATE" link={BuildingSafetyCertficate}/>
          <Row sl="5" label="FIRE SAFETY CERTIFICATE" link={FireCertificate}/>
          <Row sl="6" label="DEO CERTIFICATE" link={Dios}/>
          <Row sl="7" label="NOC CBSE" link={NOC_CBSE}/>
          <Row sl="8" label="BSA AFFILIATION LETTER CLASS 1-8" link={BSA_Permanent_Affiliation_Letter}/>
          <Row sl="9" label="WATER, HEALTH & SANITATION CERTIFICATE" link={WaterCertificate}/>
        </Section>

        <Section title="C: RESULT AND ACADEMICS">
          <Row sl="1" label="FEE STRUCTURE" link="/FeeStructure"/>
          <Row sl="2" label="ANNUAL ACADEMIC CALENDAR" link={KPSCalendor} />
          <Row sl="3" label="SCHOOL MANAGEMENT COMMITTEE (SMC)" link={SMCommitee} />
          <Row sl="4" label="PARENT TEACHER ASSOCIATION (PTA)" link={PTAssociation} />
          <Row sl="5" label="LAST THREE YEARS BOARD RESULTS" link={CBSEResult} />
          <Row sl="6" label="STAFF DETAILS" link={TEACHERLIST} />
        </Section>

        <Section title="D: STAFF (TEACHING)">
          <Row sl="1" label="PRINCIPAL" value="1" />
          <Row sl="2" label="TOTAL NO. OF TEACHERS" value="25+" />
          <Row sl="-" label="PGT" value="8" />
          <Row sl="-" label="TGT" value="12" />
          <Row sl="-" label="PRT" value="15" />
          <Row sl="3" label="TEACHER SECTION RATIO" value="1:1.8" />
          <Row sl="4" label="SPECIAL EDUCATOR" value="01" />
          <Row sl="5" label="COUNSELLOR / WELLNESS TEACHER" value="01" />
        </Section>

        <Section title="E: SCHOOL INFRASTRUCTURE">
          <Row sl="1" label="TOTAL CAMPUS AREA" value="8460 Sq. mt."/>
          <Row sl="2" label="TOTAL BUILT-UP AREA" value="2693.51 Sq. mt."/>
          <Row sl="3" label="NUMBER OF CLASSROOMS" value="28"/>
          <Row sl="4" label="NUMBER OF LABORATORIES" value="5"/>
          <Row sl="5" label="INTERNET FACILITY" value="Yes" />
          <Row sl="6" label="NO. OF GIRLS TOILETS" value="10" />
          <Row sl="7" label="NO. OF BOYS TOILETS" value="10" />
        </Section>

        <Section title="F: SELF-CERTIFICATION">
          <Row sl="1" label="SELF-CERTIFICATION PROFORMA" link={SelfCertificate}/>
        </Section>
      </div>
    </>
  );
}
